import React, {useEffect, useState} from "react";
import axios from "axios";
import {serverLink} from "../../../resources/url";
import Select from "react-select";

function ApplicantSelectOption(props) {
    const [IsLoading, setIsLoading] = useState(true)
    const [itemData, setItemData] = useState([])
    const [formData, setFormData] = useState({
        Item: "",
        ItemObject: "",
    })
    const getData = async () => {
        await axios.get(`${serverLink}staff/academics/applicant/option/list`)
            .then((result) => {
                let rows = [];
                if (result.data.length > 0) {
                    result.data.map((row) => {
                        rows.push({ value: row.APPID, label: row.FIRST_NAME +" "+ row.MIDDLE_NAME  +" "+ row.LAST_NAME +" ("+ row.APPID +")" })
                    });
                    setItemData(rows);
                }
                setIsLoading(false)
            })
            .catch((err) => {
                console.log("NETWORK ERROR");
            });
    }
    useEffect(()=> {
        getData();
    }, [""])

    const onItemChange = (e) => {
        props.setFormData({
            ...props.formData,
            APPID:e.value
        })
        setFormData({
            ...formData,
            Item: e.value,
            ItemObject: e,
        })
    }

    return (
        <Select
            name="STUDENTID"
            value={!props.formData.APPID ? formData.ItemObject : itemData.filter((e,i)=> e.value.toString() === props.formData.APPID.toString())[0]}
            onChange={onItemChange}
            options={itemData}
            placeholder={props.placeholder ?? "Select Applicant"}
        />
    )
}

export default ApplicantSelectOption;